import { getQuery, luaScript } from "../../helpers/helper_store";

const state = {
  // usersInServer: [],
  // usersNotInServer: [],
  tasksInSection: [],
  tasksNotInSection: [],
  usersInRole: [],
  usersNotInRole: [],
  basesForRole: [],
  tasksForRole: [],
  // tasksNotInRole: [],
};

const mutations = {
  // setUsersInServer: (state, data) => (state.usersInServer = Array.isArray(data) ? data : [ data ]),
  // setUsersNotInServer: (state, data) => (state.usersNotInServer = Array.isArray(data) ? data : [ data ]),
  setTasksInSection: (state, data) =>
    (state.tasksInSection = Array.isArray(data) ? data : [data]),
  setTasksNotInSection: (state, data) =>
    (state.tasksNotInSection = Array.isArray(data) ? data : [data]),
  setUsersInRole: (state, data) =>
    (state.usersInRole = Array.isArray(data) ? data : [data]),
  setUsersNotInRole: (state, data) =>
    (state.usersNotInRole = Array.isArray(data) ? data : [data]),
  setRoleTasksRights: (state, data) => (state.tasksForRole = Array.isArray(data) ? data : [ data ]),
  // setTasksNotInRole: (state, data) => (state.tasksNotInRole = Array.isArray(data) ? data : [ data ]),
  setRoleBaseRights: (state, data) =>
    (state.basesForRole = Array.isArray(data) ? data : [data])
};
function multibind({ rootState, node, idArray, action }) {
  return new Promise((resolve, reject) => {
    luaScript(
      "multibind",
      "run",
      {
        node,
        unit: idArray,
        make: action
      },
      rootState.login
    )
      .then(result => {
        //console.log('result', result);
        resolve(result);
      })
      .catch(() => {
        reject();
      });
  });
}
const actions = {
  getTasksInSection({ rootState, commit }, sectionId) {
    return new Promise((resolve, reject) => {
      getQuery("getLink_all", [sectionId], rootState.login)
        .then(result => {
          commit("setTasksInSection", result);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  getTasksNotInSection({ rootState, commit }, sectionId) {
    return new Promise((resolve, reject) => {
      getQuery("getUnLink_all", [sectionId], rootState.login)
        .then(result => {
          commit("setTasksNotInSection", result);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  getUsersInRole({ rootState, commit }, roleId) {
    return new Promise((resolve, reject) => {
      let query = "getUserInRole_all";
      if (rootState.login.user.roleid !== "0") {
        query = "getUserInRole";
      }
      getQuery(query, [roleId], rootState.login)
        .then(result => {
          commit("setUsersInRole", result);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  getUsersNotInRole({ rootState, commit }, roleId) {
    return new Promise((resolve, reject) => {
      let query = "getUserNotRole_all";
      if (rootState.login.user.roleid !== "0") {
        query = "getUserNotRole";
      }
      getQuery(query, [roleId], rootState.login)
        .then(result => {
          commit("setUsersNotInRole", result);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  getBaseRoleRights({ rootState, commit }, roleId) {
    return new Promise((resolve, reject) => {
      luaScript("usersRight", "getRight", { role: roleId }, rootState.login)
        .then(response => {
          commit("setRoleBaseRights", response);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  changeRight({ rootState, dispatch }, { funcName, roleId, idArray }) {
    return new Promise((resolve, reject) => {
      luaScript(
        "usersRight",
        funcName,
        { role: roleId, id: idArray },
        rootState.login
      )
        .then(() => {
          return dispatch("getBaseRoleRights", roleId);
        })
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  getTaskRoleRights({ rootState, commit }, roleId) {
    return new Promise((resolve, reject) => {
      luaScript("userTasks", "getRight", { role: roleId }, rootState.login)
        .then(response => {
          commit("setRoleTasksRights", response);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  changeTaskRight({ rootState, dispatch }, { funcName, roleId, idArray }) {
    return new Promise((resolve, reject) => {
      luaScript(
        "userTasks",
        funcName,
        { role: roleId, task: idArray },
        rootState.login
      )
        .then(() => {
          return dispatch("getTaskRoleRights", roleId);
        })
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  linkTasksSection({ rootState, dispatch }, { sectionId, idArray }) {
    return new Promise((resolve, reject) => {
      multibind({
        rootState,
        node: sectionId,
        idArray,
        action: "addSectionTasks"
      })
        .then(result => {
          return dispatch("getTasksInSection", sectionId);
        })
        .then(() => {
          return dispatch("getTasksNotInSection", sectionId);
        })
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  unlinkTasksSection({ rootState, dispatch }, { sectionId, idArray }) {
    return new Promise((resolve, reject) => {
      multibind({
        rootState,
        node: sectionId,
        idArray,
        action: "delSectionTasks"
      })
        .then(result => {
          return dispatch("getTasksInSection", sectionId);
        })
        .then(() => {
          return dispatch("getTasksNotInSection", sectionId);
        })
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  linkUsersRole({ rootState, dispatch }, { roleId, idArray }) {
    return new Promise((resolve, reject) => {
      multibind({ rootState, node: roleId, idArray, action: "addUserRole" })
        .then(result => {
          return dispatch("getUsersInRole", roleId);
        })
        .then(() => {
          return dispatch("getUsersNotInRole", roleId);
        })
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  unlinkUsersRole({ rootState, dispatch }, { roleId, idArray }) {
    return new Promise((resolve, reject) => {
      multibind({ rootState, node: roleId, idArray, action: "delUserRole" })
        .then(result => {
          return dispatch("getUsersInRole", roleId);
        })
        .then(() => {
          return dispatch("getUsersNotInRole", roleId);
        })
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
};

const getters = {
  // usersInServer: (state) => state.usersInServer,
  // usersNotInServer: (state) => state.usersNotInServer,
  tasksInSection: state => state.tasksInSection,
  tasksNotInSection: state => state.tasksNotInSection,
  usersInRole: state => state.usersInRole,
  usersNotInRole: state => state.usersNotInRole,
  // tasksNotInRole: (state) => state.tasksNotInRole,
  basesForRole: state => state.basesForRole,
  tasksForRole: (state) => state.tasksForRole,
};

export default {
  state,
  mutations,
  actions,
  getters
};
